import React from 'react';
import { View } from '@amzn/stencil-react-components/layout';
import { H2, TextVariant } from '@amzn/stencil-react-components/text';
import { Card } from '@amzn/stencil-react-components/card';
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button';
import { useTranslation } from 'react-i18next';
import { token } from '@amzn/stencil-design-tokens/js/web/utils';
import TranslationKeys from 'src/constants/translation-keys';
import { recordEvent } from 'src/analytics/amplify';
import JobseekerLoginImage from 'src/images/jobseeker_login_card.svg';
import {UserType} from "src/constants/usertype";
import { jobseekerLoginEndpoint } from "src/constants/auth-endpoints";

interface Props {
    screenName: string;
}

export default function JobseekerLoginCard({ screenName }: Props) {
    const { t } = useTranslation();

    const recordAndExecute = ( screenName: string) => {
        recordEvent({
            name: `${screenName}.${UserType.JOBSEEKER}.Count`,
            immediate: true
        });
        window.location.href = jobseekerLoginEndpoint();
    };

    return (
        <View style={{ paddingTop: '16px' }}>
            <Card
                data-testid="jobseeker-card"
                style={{
                    borderRadius: '8px',
                    boxShadow: 'none',
                    overflow: 'hidden',
                    border: `1px solid ${token('color.border.primary')}`,
                    display: 'flex',
                    flexDirection: 'row',
                }}
                padding={{ top: '16px', bottom: '0px', left: '16px', right: '16px' }}
            >
                <View style={{ flex: 1, display: 'flex', flexDirection: 'column' }} padding={{ bottom: '16px' }}>
                    {/* <h2> under the page's single <h1>; the LabelMD variant keeps the
                        typography this card had as a <label>. */}
                    <H2 variant={TextVariant.LabelMD}
                        data-testid="jobseeker-card-heading"
                        style={{ fontWeight: 700, fontSize: '20px', marginBottom: '8px', color: token('color.text.primary') }}>
                        {t(TranslationKeys.UI.USERTYPES.JOBSEEKER_HEADER)}
                    </H2>
                    <span style={{ fontSize: '18px', color: token('color.text.secondary') }}>
                        {t(TranslationKeys.UI.USERTYPES.JOBSEEKER_DESCRIPTION)}
                    </span>
                    <View style={{ marginTop: '10px' }}>
                        <Button
                            onClick={() => {
                                recordAndExecute(screenName);
                            }}
                            variant={ButtonVariant.Tertiary}
                            style={{
                                paddingLeft: '24px',
                                paddingRight: '24px',
                                border: `3px solid ${token('color.border.primary')}`,
                            }}
                        >
                            {t(TranslationKeys.UI.BUTTONS.LOGIN)}
                        </Button>
                    </View>
                </View>
                <img src={JobseekerLoginImage} alt="" style={{ maxWidth: '30%', height: 'auto', alignSelf: 'flex-end' }} />
            </Card>
        </View>
    );
}
